import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/banners/getList ',
    method: 'post',
    params
  })
}

export function deleteMessage(params) {
  return request({
    url: '/banners/delete',
    method: 'post',
    params
  })
}

export function addMessage(params) {
  return request({
    url: '/banners/addMessage',
    method: 'post',
    params
  })
}

export function updateMessage(params) {
  return request({
    url: '/banners/updateMessage',
    method: 'post',
    params
  })
}

export function getBanners(params) {
  return request({
    url: '/banners/getBanners',
    method: 'post',
    params
  })
}
